// Unverified contact data is functional form state, never identity evidence.
// Per-tab, per-flow, bounded to 30 minutes; codes/proofs never enter storage.
export type CheckoutCustomerDraft = { firstName: string; lastName: string; email: string };
const PREFIX = "bac:checkout-customer:";
const TTL = 30 * 60 * 1000;
export const emptyCustomerDraft = (): CheckoutCustomerDraft => ({ firstName: "", lastName: "", email: "" });
export function readCheckoutCustomerDraft(flowId: string): CheckoutCustomerDraft {
  try {
    const raw = JSON.parse(sessionStorage.getItem(PREFIX + flowId) || "null");
    if (!raw || typeof raw.expiresAt !== "number" || raw.expiresAt <= Date.now()) {
      clearCheckoutCustomerDraft(flowId);
      return emptyCustomerDraft();
    }
    const result = emptyCustomerDraft();
    for (const key of Object.keys(result) as (keyof CheckoutCustomerDraft)[]) {
      if (typeof raw.data?.[key] === "string") result[key] = raw.data[key].slice(0, key === "email" ? 254 : 100);
    }
    return result;
  } catch { return emptyCustomerDraft(); }
}
export function saveCheckoutCustomerDraft(flowId: string, data: CheckoutCustomerDraft): void {
  try { sessionStorage.setItem(PREFIX + flowId, JSON.stringify({ data, expiresAt: Date.now() + TTL })); } catch { /* memory state remains usable */ }
}
export function clearCheckoutCustomerDraft(flowId: string): void {
  try { sessionStorage.removeItem(PREFIX + flowId); } catch { /* best effort */ }
}

export function clearAllCheckoutCustomerDrafts(): void {
  try {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);
      if (key?.startsWith(PREFIX)) sessionStorage.removeItem(key);
    }
  } catch { /* A blocked storage API must not prevent sign-out. */ }
}
